"use strict";

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
function loadScript(src, done) {
  var js = document.createElement('script');
  js.src = src;

  js.onload = function () {
    if (done) {
      done();
    }
  };

  js.onerror = function () {
    console.error('Failed to load script ' + src);

    if (done) {
      done();
    }
  };

  document.head.appendChild(js);
}

document.addEventListener('discount_kit:cart_changed', () => {
  // If on cart page, reload the page
  if (window.location.pathname.includes('/cart')) {
    window.location.reload();
    return;
  }

  // Trigger cart drawer refresh and open it
  document.dispatchEvent(new CustomEvent('product:added', {
    detail: {
      quantity: 0
    }
  }));

  // Wait a bit for the cart to rerender, then update the count
  setTimeout(() => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update the cart count in header
        const countElements = document.querySelectorAll('.Header__CartCount, .Header__CartDotCount');
        countElements.forEach(el => {
          el.textContent = cart.item_count;
        });

        // Update the cart dot visibility
        const cartDots = document.querySelectorAll('.Header__CartDot');
        cartDots.forEach(dot => {
          if (cart.item_count === 0) {
            dot.classList.remove('is-visible');
          } else {
            dot.classList.add('is-visible');
          }
        });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }, 500);
});

/** Start Global-E Modal Accessibility **/
  // Function to apply accessibility attributes and focus trap
  function enhanceGEModalAccessibility() {
    var recommendationModal = document.querySelector('.recommendation-modal__container');

    if (recommendationModal) {
      // Add aria-modal attribute to make it recognized as a modal
      recommendationModal.setAttribute('aria-modal', 'true');
      recommendationModal.setAttribute('role', 'dialog');

      // Define the first and last focusable elements within the modal
      var firstFocusableElement = recommendationModal.querySelector('.recommendation-modal__close-button');
      var lastFocusableElement = recommendationModal.querySelector('.recommendation-modal__button--minimal');

      // Add aria-label="Close" to the close button for better accessibility
      var closeButton = firstFocusableElement;
      if (closeButton) {
        closeButton.setAttribute('aria-label', 'Close country selector modal');
      }

      // Event listener to trap focus within the modal
      recommendationModal.addEventListener('keydown', function(e) {
        if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableElement.focus();
        } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      });
    }
  }

  // Set up a MutationObserver to watch for the modal being added to the DOM
  var GEModalObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        // Check each added node to see if it's the modal or contains the modal
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Check only element nodes
            if (node.matches('.recommendation-modal__container') || node.querySelector('.recommendation-modal__container')) {
              enhanceGEModalAccessibility();
            }
            if (node.matches('.recommendation-modal__flag') || node.querySelector('.recommendation-modal__flag')) {
              enhanceGEModalAccessibility();
              var modalHeading = document.querySelector('.recommendation-modal__message');
              modalHeading.setAttribute('tabindex', '0');
              modalHeading.focus();
            }
            // Focus on "Change country/region" heading after clicking that link
            var alignStartMessage = node.matches('.recommendation-modal__message--align-start') ? node : node.querySelector('.recommendation-modal__message--align-start');
            if (alignStartMessage) {
              enhanceGEModalAccessibility();
              alignStartMessage.setAttribute('tabindex', '0');
              alignStartMessage.focus();
              // Add label to select field
              var selectField = document.querySelector('.recommendation-modal__selector--flag');
              if (selectField) {
                selectField.setAttribute('id', 'country_code__selector');

                // Create the visually hidden label
                var label = document.createElement('label');
                label.setAttribute('for', 'country_code__selector');
                label.classList.add('screenreader');
                label.textContent = 'Change country/region';

                // Insert the label into the DOM
                selectField.parentNode.insertBefore(label, selectField);
              }
            }
          }
        });
      }
    });
  });

  // Start observing the document body for child nodes being added
  GEModalObserver.observe(document.body, {
    childList: true, // Observe direct children
    subtree: true, // Observe all descendants
  });
/** End Global-E Modal Accessibility **/

/**
 * Flickity iOS 13 Fix
 *
 * GitHub issue - https://github.com/metafizzy/flickity/issues/959
 * gist - https://gist.github.com/bakura10/b0647ef412eb7757fa6f0d2c74c1f145
 *
 */
(function () {
  var touchingCarousel = false,
    touchStartCoords;
  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY,
    };
  });
  document.body.addEventListener(
    'touchmove',
    function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y,
      };
      if (Math.abs(moveVector.x) > 7) e.preventDefault();
    },
    {
      passive: false,
    }
  );

  // Add accessibility to Flickity carousel
  addFlickityAccessibility();
})();

// Add accessibility to Flickity carousel
function addFlickityAccessibility() {
  const carouselObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.target.className.includes('flickity-enabled') || mutation.target.className.includes('nosto-carousel')) {
        const $carousel = mutation.target;
        const $prevButton = $carousel.querySelector('.flickity-prev-next-button.previous');
        const $nextButton = $carousel.querySelector('.flickity-prev-next-button.next');
        const $carouselParents = getParents($carousel);
        const $section = $carouselParents.find(($carouselParent) => $carouselParent.classList?.contains('Section'));
        const $carouselWrapper = $carouselParents.find(($carouselParent) => $carouselParent.classList?.contains('ProductListWrapper'));
        const $sectionTitle = $section?.querySelector('.SectionHeader__Heading');
        const ariaLabel = `${$sectionTitle?.innerText} carousel` || 'carousel';
        const $carouselInstructions = document.createElement('p');
        $carouselInstructions.classList.add('screenreader');
        $carouselInstructions.innerText = SDG.Data.carouselInstructions;
        $carouselWrapper.setAttribute('aria-label', ariaLabel);
        $carouselWrapper.setAttribute('role', 'region');

        if (!$carouselWrapper.querySelector('.screenreader')) {
          $carouselWrapper.prepend($carouselInstructions);
        }

        if (($prevButton && $prevButton.hasAttribute('disabled')) && ($nextButton && $nextButton.hasAttribute('disabled'))) {
          $prevButton.classList.add('no-opacity');
          $nextButton.classList.add('no-opacity');
        }

        if (($prevButton && !$prevButton.hasAttribute('disabled')) && ($nextButton && !$nextButton.hasAttribute('disabled'))) {
          $prevButton.classList.remove('no-opacity');
          $nextButton.classList.remove('no-opacity');
        }

        carouselObserver.disconnect();
      }
    });
  });

  carouselObserver.observe(
    document.querySelector('main'),
    {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    }
  );
}

// Hide disabled carousel buttons when all disabled
function updateCarouselButtons() {
  // Check if the carousel button exists before trying to observe it
  const nextButton = document.querySelector('.flickity-prev-next-button.next');

  if (!nextButton) {
    // Exit early if carousel is not present on the page
    return;
  }

  const buttonObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      let $prevButton;
      let $nextButton;

      if (mutation.target.attributes['disabled']) {
        $prevButton = mutation.target.previousElementSibling;
        $nextButton = mutation.target;

        // Additional null checks for safety
        if ($prevButton && $nextButton &&
            $prevButton.hasAttribute('disabled') && $nextButton.hasAttribute('disabled')) {
          $prevButton.classList.add('no-opacity');
          $nextButton.classList.add('no-opacity');
          buttonObserver.disconnect();
        }
      }

      if (!mutation.target.attributes['disabled']) {
        $prevButton = mutation.target.previousElementSibling;
        $nextButton = mutation.target;

        // Additional null checks for safety
        if ($prevButton && $nextButton &&
            (!$prevButton.hasAttribute('disabled') || !$nextButton.hasAttribute('disabled'))) {
          $prevButton.classList.remove('no-opacity');
          $nextButton.classList.remove('no-opacity');
          buttonObserver.disconnect();
        }
      }
    });
  });

  buttonObserver.observe(nextButton, {
    subtree: false,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled'],
  });
}

// Get element parents
function getParents(el) {
  for (var parents = []; el; el = el.parentNode) {
    parents.push(el);
  }

  return parents;
}

// Resize event
window.addEventListener('resize', () => {
  const $nostoCarousels = document.querySelectorAll('.ProductList--carousel');
  updateCarouselButtons();

  $nostoCarousels.forEach(($nostoCarousel) => {
    if (window.innerWidth > 992) {
      // Remove tabindex attribute from Nosto carousels on resize
      if ($nostoCarousel.hasAttribute('tabindex')) {
        $nostoCarousel.removeAttribute('tabindex');
      }
    }
  });
});

// Get element parents
function getParents(el) {
  for (var parents = []; el; el = el.parentNode) {
    parents.push(el);
  }

  return parents;
}

// Checkout Address Character Limits
function setShippingAddressCharLimits() {
  var maxCharAddress = 35;
  var maxCharName = 17;
  var $firstNameShip = document.getElementById('checkout_shipping_address_first_name');
  var $lastNameShip = document.getElementById('checkout_shipping_address_last_name');
  var $addressFieldShip = document.getElementById('checkout_shipping_address_address1');
  var $apartmentFieldShip = document.getElementById('checkout_shipping_address_address2');
  var $cityFieldShip = document.getElementById('checkout_shipping_address_city');
  var $zipFieldShip = document.getElementById('checkout_shipping_address_zip');
  var $phoneFieldShip = document.getElementById('checkout_shipping_address_phone');

  if ($firstNameShip) {
    $firstNameShip.maxLength = maxCharName;
    $lastNameShip.maxLength = maxCharName;
    $addressFieldShip.maxLength = maxCharAddress;
    $apartmentFieldShip.maxLength = maxCharAddress;
    $cityFieldShip.maxLength = maxCharAddress;
    $zipFieldShip.maxLength = maxCharAddress;
    $phoneFieldShip.maxLength = maxCharAddress;
  }
}

// Billing Address Character Limits
function setBillingAddressCharLimits() {
  var maxCharAddress = 35;
  var maxCharName = 17;
  var $firstNameBill = document.getElementById('checkout_billing_address_first_name');
  var $lastNameBill = document.getElementById('checkout_billing_address_last_name');
  var $addressFieldBill = document.getElementById('checkout_billing_address_address1');
  var $apartmentFieldBill = document.getElementById('checkout_billing_address_address2');
  var $cityFieldBill = document.getElementById('checkout_billing_address_city');
  var $zipFieldBill = document.getElementById('checkout_billing_address_zip');
  var $phoneFieldBill = document.getElementById('checkout_billing_address_phone');

  if ($firstNameBill) {
    $firstNameBill.maxLength = maxCharName;
    $lastNameBill.maxLength = maxCharName;
    $addressFieldBill.maxLength = maxCharAddress;
    $apartmentFieldBill.maxLength = maxCharAddress;
    $cityFieldBill.maxLength = maxCharAddress;
    $zipFieldBill.maxLength = maxCharAddress;
    $phoneFieldBill.maxLength = maxCharAddress;
  }
};

// Checkout events
document.addEventListener('keydown', setShippingAddressCharLimits);
document.addEventListener('keydown', setBillingAddressCharLimits);

// Get Cart Contents For GWP Functionality
if (typeof cartGWP !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    cartGWP(true);
  });
}

const searchClearDesktop = document.getElementById('searchClear');
if (searchClearDesktop) {
  searchClearDesktop.onclick = function () {
    $('.Search__Form__Desktop .searchBox').val('');
  };
}

// Add to Cart Button - Returns focus to "Add to Cart" when Cart Modal is closed
function returnCartFocus() {
  const addBtn = document.getElementById('cartBtn');
  const sideCart = document.getElementById('sidebar-cart');
  const cartClose = document.getElementById('cartClose');

  if (addBtn) {
    addBtn.addEventListener('click', () => {
      const previousActiveElement = document.activeElement;
      // Checks if cart is open. Setimeout to allow product to load into the cart
      if (sideCart.getAttribute('aria-hidden') === 'false') {
        cartClose.onclick = function () {
          previousActiveElement.focus();
        };
      }
    });
  }
}
returnCartFocus();

function variantOptionCheck() {
  const variantOptions = document.querySelectorAll('.js-option');
  const addToCartButton = document.getElementById('cartBtn');
  const addToCartMessage = document.getElementById('pmAddToCartMessage');

  variantOptions.forEach((label) => {

    label.addEventListener('click', () => {
      addToCartButton.classList.remove('disabled');
      addToCartMessage.classList.remove('show-message');
    });
  });

}

variantOptionCheck();

// Trap Focus Function
function trapFocus(element) {
  const KEYCODE_TAB = 9; // Tab keycode
  const focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])');
  let length = Object.keys(focusableEls).length;

  // Removes all DOM-hidden elements from focusableEls
  while (focusableEls[length - 1].offsetParent === null) {
    delete focusableEls[length - 1];
    length -= 1;
  }

  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[length - 1];

  firstFocusableEl.focus();

  function addEvent(e) {
    const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    if (!isTabPressed) return;

    if (e.shiftKey && document.activeElement === firstFocusableEl) /* shift + tab */ {
      lastFocusableEl.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === lastFocusableEl) /* tab */ {
      firstFocusableEl.focus();
      e.preventDefault();
    }
  }

  element.addEventListener('keydown', addEvent);
}

function estimateShip() {
  const estimate = document.getElementById('estimateShipping');
  if (estimate != undefined) {
    estimate.addEventListener('click', () => {
      setTimeout(() => {
        const results = document.querySelector('.ShippingEstimator__ResultsInner');
        const errorList = document.querySelector('.Alert__ErrorList');
        const estimateErr = document.querySelector('.js-error-item');

        if (errorList) {
          errorList.setAttribute('role', 'presentation');
        }

        if (estimateErr) {
          estimateErr.focus();
        }

        if (results) {
          results.innerHTML = results.innerHTML.replace('<p>', '<h3>');
          results.innerHTML = results.innerHTML.replace('</p>', '</h3>');
        }
      }, 2000);
    });
  }
}
estimateShip();

// For ADA, PDP Carousel will focus on image when Flickity dot is clicked
function imageFocus() {
  const dotButtons = document.querySelectorAll('.js-image-focus');
  if (dotButtons.length > 0) {
    for (let i = 0; i < dotButtons.length; i += 1) {
      dotButtons[i].addEventListener('click', () => {
        const imageLink = dotButtons[i].getAttribute('href').substring(1);
        const focusImage = document.getElementById(imageLink);
        focusImage.setAttribute('tabindex', '-1');
        focusImage.focus();
      });
    }
  }
}
imageFocus();

// For ADA, focus is taken to #main after "Skip To Content" button is clicked
function skipToContent() {
  const skipBtn = document.getElementById('skipToContent');
  if (skipBtn) {
    const skipToLink = document.getElementById(skipBtn.getAttribute('href').substring(1));
    skipBtn.addEventListener('click', () => {
      skipToLink.setAttribute('tabindex', '-1');
      skipToLink.focus();
    });
  }
}
skipToContent();

function quickViewCheckLowStock(selectedVariant) {
    var variantId = selectedVariant.id;
    var lowStockElements = document.querySelectorAll('.lowStock');
    if (lowStockElements.length > 0) {
      lowStockElements.forEach(elem => { elem.style.display = 'none'; })
    }
    var lowStockElement = document.querySelectorAll('[data-lowStockId="'+variantId+'"]');
    if (lowStockElement != undefined && lowStockElement.length > 0) {
      lowStockElement[0].style.display = 'block';
    }
    var notifyMeElements = document.querySelectorAll('.notifyMe');
    if (notifyMeElements.length > 0) {
      notifyMeElements.forEach(elem => { elem.style.display = 'none'; })
    }
    var isNotifyMe = $("#isNotifyMe").val();
    if (isNotifyMe==1 && selectedVariant.available ==0) {
      var notifyMeElement = document.querySelectorAll('[data-notifyMeId="'+variantId+'"]');
      if (notifyMeElement != undefined && notifyMeElement.length > 0) {
        notifyMeElement[0].style.display = 'block';
        var href = $(notifyMeElement).find('a').attr('href');
        setTimeout(function() {
          var html = '<a href="'+href+'">NOTIFY ME</a>';
          $("#boost-pfs-quickview-cart-btn-text").html(html);
        },100);
      }
    }
}

jQuery(window).on('load', function() {
  if (window.location.pathname=='/collections/all-shoes' && window.location.search=='') {
    jQuery(".boost-pfs-filter-tree-mobile-button button").click();
  }
  if (window.location.pathname=='/collections/archive-sale' && window.location.search.includes('bysize=1')) {
    jQuery(".boost-pfs-filter-tree-mobile-button button").click();
  }
  jQuery('main').on('click', '.boost-pfs-filter-tree-desktop-button', function() {
    jQuery(".boost-pfs-filter-tree-mobile-button button").click();
  });

  /** QUICK VIEW BUTTON **/
  // Handle both click and touch events for mobile compatibility
  jQuery('.boost-pfs-filter-right-col').on('click touchstart','.quick-add',function(evt) {
    // Stop the parent card link navigation
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    // Prevent any default touch behavior on mobile
    if (evt.type === 'touchstart') {
      // Store a flag to indicate we've handled this touch
      const $this = jQuery(this);
      $this.data('touch-handled', true);

      // Track if finger moved away from element
      $this.data('touch-moved', false);

      // Add touchmove handler to detect if finger moves away
      $this.on('touchmove.quickview', function(moveEvt) {
        const touch = moveEvt.originalEvent.touches[0];
        const elementFromPoint = document.elementFromPoint(touch.clientX, touch.clientY);

        // Check if the finger is still over this element or its children
        if (!$this.is(elementFromPoint) && !$this.has(elementFromPoint).length) {
          $this.data('touch-moved', true);
        }
      });

      // Add a one-time touchend handler to prevent the subsequent click
      $this.one('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Remove the touchmove handler
        $this.off('touchmove.quickview');

        // Only trigger the quick view if the finger is still on the element
        if (!$this.data('touch-moved')) {
          // Click the quick view button
          $this.parent().parent().find('.boost-pfs-quickview-btn').click();
        }

        return false;
      });

      return false;
    } else if (evt.type === 'click' && !jQuery(this).data('touch-handled')) {
      // Only process click if it wasn't already handled by touch
      // Click the quick view button
      jQuery(this).parent().parent().find('.boost-pfs-quickview-btn').click();
    }

    // Reset the touch-handled flag
    jQuery(this).data('touch-handled', false);
    return false;
  });
  /** END QUICK VIEW BUTTON **/

  jQuery('.product-detail-list .list-product-details p.read-more-meta').click(function () {
    var parentElement = jQuery(this).parent();
    parentElement.toggleClass('active');
    if (parentElement.hasClass('active')) {
      jQuery(this).text('View less');
    } else {
      jQuery(this).text('Read more');
    }
  });

  jQuery('.pdp-accordion h2 span').click(function () {
    var $accordion = jQuery(this).closest('.pdp-accordion');
    jQuery('.pdp-accordion').not($accordion).removeClass('active');
    $accordion.toggleClass('active');
  });
});

jQuery('.mobile-product-slider').on('init reInit afterChange', function(event, slick) {
  slick.$dots.find('li button').removeAttr('aria-current');
  slick.$dots.find('li.slick-active button').attr('aria-current', 'true');
});

jQuery('.mobile-product-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 2,
    initialSlide: 1,
    lazyLoad: 'ondemand',
    responsive: [
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 2,
                initialSlide: 0,
                dots: true,
                arrows: false,
                infinite: true,
                centerMode: true
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 1,
                initialSlide: 0,
                dots: true,
                arrows: false,
                infinite: true,
                centerMode: true
            }
        }
    ]
});

// For ADA, adds 'tabindex="0"' to the li elements in the slick dots
function detectSlickDots() {
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.target.className.includes('slick-initialized')) {
        const $slickDots = document.querySelectorAll('.slick-dots');

        $slickDots.forEach(($dots) => {
          $dots.setAttribute('tabindex', '0');

          const $dotsList = $dots.querySelectorAll('li');
          $dotsList.forEach(($dot) => {
            $dot.setAttribute('tabindex', '0');
            $dot.addEventListener('keydown', (e) => {
              const $dotBtn = e.target.querySelector('button');
              if (e.key === 'Enter') {
                $dotBtn.click();
              }
            });
          });
        });
      }
    });
  });

  observer.observe(
    document.querySelector('body'),
    {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    }
  );
}

detectSlickDots();

// For ADA, adds aria-current on current slide dot
function detectActiveDot() {
  const $activeDot = document.querySelector('.js-index-carousel');
  if ($activeDot) {
    const dots = $activeDot.querySelectorAll('.dot');
    dots.forEach((dot) => {
      const isSelected = _.hasClass(dot, 'is-selected');
      if (isSelected) {
        dot.setAttribute('aria-current', true);
      } else {
        dot.removeAttribute('aria-current');
      }

      dot.addEventListener('transitionend', () => {
        const isSelected = _.hasClass(dot, 'is-selected');
        if (isSelected) {
          dot.setAttribute('aria-current', true);
        } else {
          dot.removeAttribute('aria-current');
        }
      })
    });
  }
}
detectActiveDot();

document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.swiffy-slider[data-section-name="Newest Releases"]');
  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll('.slider-container > div');
    let currentIndex = 0; // Track the current index of the leftmost visible slide

    // Function to update visibility and accessibility attributes
    function updateAccessibilityAttributes() {
      slides.forEach((slide, index) => {
        // Now checks if the slide is within the range of the next three slides to be visible
        let isVisible = index >= currentIndex && index < currentIndex + 3;
        slide.setAttribute('aria-hidden', String(!isVisible));
        slide.setAttribute('aria-current', isVisible ? 'true' : 'false');

        // Find all focusable elements within the slide
        const focusables = slide.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');

        // Update tabindex to make elements non-focusable if their slide is hidden
        focusables.forEach(el => {
          el.setAttribute('tabindex', isVisible ? '0' : '-1');
        });
      });
    }

    // Adjusts currentIndex based on slider navigation and ensures the attributes are updated accordingly
    const nextButton = slider.querySelector('.slider-nav-next');
    const prevButton = slider.querySelector('.slider-nav');
    const sliderWrapper= slider.querySelector('.slider-indicators');
    const sliderNav = slider.querySelectorAll('.slider-indicators > li');
    nextButton.addEventListener('click', () => {
      if (currentIndex < slides.length - 3) currentIndex += 1; // Moves one slide forward
      updateAccessibilityAttributes();
    });
    prevButton.addEventListener('click', () => {
      if (currentIndex > 0) currentIndex -= 1; // Moves one slide backward
      updateAccessibilityAttributes();
    });

    // Initial visibility update
    updateAccessibilityAttributes();

    const observer = new MutationObserver(() => {
      sliderNav.forEach((li) => {
        const button = li.querySelector('button');
        button.removeAttribute('aria-current');

        if (li.classList.contains('active')) {
          button.setAttribute('aria-current', 'true');
        }
      });
    });

    observer.observe(sliderWrapper,
      {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      }
    );
  });
});

// Sticky header
(function () {
  $(window).on('scroll', function() {
    if ($(this).scrollTop() >= 53) {
      $('body').addClass('stickyscroll');
    } else {
      $('body').removeClass('stickyscroll');
    }
  });
})();


// Attentive
(function () {
  $(".AnnouncementBar__Slide").on("click","#attn_ann",function() {
    if(window.innerWidth >= 760){
      //call the desktop creative
      window.__attentive.trigger(null,null,null,350971)
    } else {
      //call the mobile creative
      window.__attentive.trigger(null,null,null,350967)
    }
  });
})();

// Back to top
(function() {
    var goTopBtn = document.querySelector('.back-to-top');

    function trackScroll() {
      const scrolled = window.pageYOffset;
      const coords = 300;

      if (scrolled > coords) {
        goTopBtn.classList.add('showbtt');
        goTopBtn.disabled = false;
      } else {
        goTopBtn.classList.remove('showbtt');
        goTopBtn.disabled = true;
      }
    }

    function backToTop(e) {
      e.preventDefault(); // prevent link jump
      window.scrollTo({ top: 0, behavior: 'smooth' });

      const main = document.getElementById('main-content');
      if (main) {
          main.setAttribute('tabindex', '-1'); // temporarily make it focusable
          main.focus();
      }
    }

    window.addEventListener('scroll', trackScroll);
    goTopBtn.addEventListener('click', backToTop);
    goTopBtn.addEventListener('keydown', function(e) {
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        e.preventDefault();
        backToTop(e);
      }
    });
})();



// Slick Slider ADA - ensure controls are not tabbable on hidden slides when slides change
jQuery(document).ready(function () {
  function updateSlickSlideFocus($slider) {
    $slider.find('.slick-slide').each(function () {
      var $slide = jQuery(this);
      var isHidden = $slide.attr('aria-hidden') === 'true';

      // Fix the <li>
      if (isHidden) {
        $slide.attr('tabindex', -1);
      } else {
        $slide.removeAttr('tabindex');
      }

      // Fix internal focusables
      $slide.find('a, button, input, select, textarea, [tabindex]').each(function () {
        if (isHidden) {
          jQuery(this).attr('tabindex', -1);
        } else {
          jQuery(this).removeAttr('tabindex');
        }
      });
    });
  }

  // Apply fix to all slick sliders on the page
  jQuery('.slick-slider').each(function () {
    var $slider = jQuery(this);

    $slider.on('afterChange.slickADA', function () {
      setTimeout(function () {
        updateSlickSlideFocus($slider);
      }, $slider.slick('slickGetOption', 'speed') || 300);
    });

    // Run once in case init already happened
    updateSlickSlideFocus($slider);
  });
});
